export default __webpack_public_path__ + "static/media/tube_placed.dde5d473.svg";